export default class MassiaOnoffController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'MassiaSelectService',
		'notification',
		'$location',
		'$translate',
		'SharedDataService',
		'$attrs',
		'MassiaSelectSupervisorService'
	];

	constructor(
		$scope,
		$state,
		$stateParams,
		MassiaDateService,
		notification,
		$location,
		$translate,
		SharedDataService,
		$attrs,
		MassiaSelectSupervisorService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.MassiaDateService = MassiaDateService;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$attrs = $attrs;
		this.MassiaSelectSupervisorService = MassiaSelectSupervisorService;
		this.searchText = '';
		this.name = this.$attrs.name;
		this.filteredOptions = [];
		this.messageError = '';
		this.error = false;
	}

	async $onInit() {
		// Créer la promise pour le supervisor
		this.readyPromise = new Promise((resolve) => (this._resolveReady = resolve));
		//Abonnement au Supervisor
		this.MassiaSelectSupervisorService.addController(this);

		this.isEditMode = false;

		this.SharedDataService.setData(this.name, this.ngModel);

		this.$scope.$watch(
			() => this.ngModel,
			(newValue, oldValue) => {
				console.log(newValue);
				if (newValue !== oldValue) {
					this.SharedDataService.setData(this.name, this.ngModel);
					if (this.ngChange) {
						this.ngChange();
					}
				}
			}
		);

		//On prévient le superviseur qu'on est prêt
		this.initComplete = true;
		this._resolveReady();
	}

	toggleSwitch() {
		if (event.keyCode === 13 || event.keyCode === 32) {
			// 13 pour Entrée, 32 pour Espace
			event.preventDefault();
			this.ngModel = !this.ngModel;
		}
	}

	async verifyForm(newValueObject) {
		//console.log(newValueObject);
		this.error = false;
		if (newValueObject && newValueObject.messageType === 'error') {
			this.error = true;
			this.messageError = newValueObject.message;
		}
	}

	$onDestroy() {
		this.MassiaSelectSupervisorService.removeController(this);
	}

	reset() {
		this.ngModel = 0;
		this.searchText = '';
		this.options = [];
	}

	onFocus() {
		this.isFocused = true;
	}
}
